import { type EntitlementRemoveInput, type EntitlementRemoveSuccess } from '@terros/common'
import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useEntitlementCache } from './cache'

export function useRemoveEntitlements(): RemoveHookResponse<EntitlementRemoveInput> {
  const mutation = useTantalimMutation<EntitlementRemoveInput, EntitlementRemoveSuccess>({ url: '/entitlement/remove' })
  const cache = useEntitlementCache()
  async function remove(input: EntitlementRemoveInput): Promise<void> {
    await mutation.mutateAsync(input)
    cache.clearList(input.entityId)
  }
  return mutationRemove(mutation, remove)
}
